import { store as createStore, autoEffect } from '@risingstack/react-easy-state'
import api from '../api'
import { InquiryFrequencies } from '../constants/InquiryFrequencies'
import { InquiryTypes } from '../constants/InquiryTypes'
import { read, write } from '../utilities/local-storage'
import { debug } from '../utilities/logger'
import { getRandomInArray } from '../utilities/arrays'

export const InquiryPathVersions = {
  V1: 1,
  V2: 2
}

/**
 * [Store]
 */
const DEFAULT_STORE = {
  step: 0,
  pathVersion: getRandomInArray([InquiryPathVersions.V1, InquiryPathVersions.V2]),
  frequency: InquiryFrequencies.PONCTUAL,
  type: InquiryTypes.VISIT,
  selected: [],
  withVisit: false,
  gardenSurface: '',
  description: '',
  duration: {
    hours: '0',
    minutes: '0'
  },
  disponibilities: [
    { daytime: 'full', date: null },
    { daytime: 'full', date: null },
    { daytime: 'full', date: null }
  ],
  address: {
    address: '',
    zipCode: '',
    city: ''
  },
  lastName: '',
  firstName: '',
  phone: '',
  email: '',
  invoicing: {
    address: '',
    zipCode: '',
    city: ''
  },
  appliedCouponCodeId: null
}

const store = createStore({
  ...DEFAULT_STORE,
  initialized: false,
  initialize,
  clear,
  setFrequency,
  setType,
  setAccount,
  setAddress,
  enableAutoPersist,
  loadCache,
  submit
})

/**
 * [Cache management]
 */
const INQUIRY_STORAGE_KEY = 'stores.inquiry'
function load () { return read(INQUIRY_STORAGE_KEY) }
function persist () { write(INQUIRY_STORAGE_KEY, store) }

function loadCache () {
  debug('[store][inquiry.loadCache]')
  const values = load()
  Object.keys(values).forEach((key) => {
    store[key] = values[key]
  })
}

function enableAutoPersist () {
  autoEffect(() => {
    debug('[store][inquiry.autoeffect]')
    persist()
  })
}

function initialize () {
  if (store.initialized) { return }
  loadCache()
  enableAutoPersist()
  store.initialized = true
}

/**
 * [Functions]
 */
function clear () {
  Object.keys(DEFAULT_STORE).forEach((key) => {
    store[key] = DEFAULT_STORE[key]
  })
}

function setFrequency ({ frequency }) {
  store.frequency = frequency
  if (frequency === InquiryFrequencies.MAINTENANCE) {
    store.withVisit = true
    store.type = InquiryTypes.VISIT
  } else {
    store.withVisit = null
  }
}

function setType ({ type }) {
  if (!store.withVisit) {
    store.type = type
  }
}

function setAccount ({ account }) {
  const copy = JSON.parse(JSON.stringify(account))
  store.gardenSurface = copy.gardenSurface
  // Removing account fields we don't want in inquiry
  store.address = {
    ...copy.address,
    deptCode: null,
    regionDisplay: null
  }
  store.invoicing = copy.address
  store.firstName = copy.firstName
  store.lastName = copy.lastName
  store.phone = copy.phone
  store.email = copy.email
}

function setAddress ({ postalCode, city, address }) {
  store.address.address = address || store.address.address
  store.address.city = city || store.address.city
  store.address.zipCode = postalCode || store.address.zipCode
}

async function submit ({ leadFunnel = null, attribution = null } = {}) {
  // Lead qualification data lives outside the inquiry (search store / first-touch attribution)
  const inquiry = { ...store, leadFunnel, attribution }
  if (store.frequency === InquiryFrequencies.PONCTUAL) {
    return api.inquiries.ponctual.create(inquiry)
  } else if (store.frequency === InquiryFrequencies.MAINTENANCE) {
    return api.inquiries.maintenance.create(inquiry)
  } else { debug(`[store][inquiry.submit] Unable to find a strategy to post type ${store.type}`) }
}

export default store



// WEBPACK FOOTER //
// ./src/stores/inquiry.js